import { render, staticRenderFns } from "./EditPriceOrderItem.vue?vue&type=template&id=1e286148"
import script from "./EditPriceOrderItem.vue?vue&type=script&lang=js"
export * from "./EditPriceOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports